module.exports = __webpack_public_path__ + "static/media/GooglePlay.097ec85b.svg";